import { TableColumn } from "../table/TableColumn";

const DeviceScheduleColumn : TableColumn[] =  [
    {
        heading: "Mode",
        accessor: "mode",
        isNumeric: false,
        id: 0,
        active: true,
        translationKey: "mode"
    },
    {
        heading: "Time Pattern",
        accessor: "deviceTimePatternName",
        isNumeric: false,
        id: 1,
        active: true,
        translationKey: "timePattern"
    },
    {
        heading: "Start Date",
        accessor: "startDate",
        isNumeric: false,
        id: 2,
        active: true,
        translationKey: "startDate",
    },
    {
        heading: "End Date",
        accessor: "endDate",
        isNumeric: false,
        id: 3,
        active: true,
        translationKey: "endDate",
    },
    {
        heading: "Start Time",
        accessor: "startTime",
        isNumeric: false,
        id: 4,
        active: true,
        translationKey: "startTime",
    },
    {
        heading: "End Time",
        accessor: "endTime",
        isNumeric: false,
        id: 5,
        active: true,
        translationKey: "endTime",
    },
    {
        heading: "Days",
        accessor: "days",
        isNumeric: false,
        id: 6,
        active: true,
        translationKey: "days",
    },
];

export default DeviceScheduleColumn;
